export const name = /[a-zA-Z\u00C0-\u00FF ]{2,} [a-zA-Z\u00C0-\u00FF ]{1}[a-zA-Z\u00C0-\u00FF ]*/;

export const email = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}[\s]*$/i;

// eslint-disable-next-line no-useless-escape
export const phone = /^(?:\(\d{2}\)\s?(9\d{4}-\d{4}|\d{4}-\d{4})|\d{2}(9\d{8}|\d{8}))$/;

// eslint-disable-next-line no-useless-escape
export const birthData = /^(0[1-9]|1\d|2\d|3[0-1])(\/|\-|\.|)(0[1-9]|1[0-2])\2\d{4}$/i;

export const address = /^[a-zA-Z\u00C0-\u00FF0-9 ]{3,}$/;

export const hsNumber = /[0-9]{1,}/;

export const district = /^[a-zA-Z\u00C0-\u00FF0-9\s'’\-(),.]{2,}$/i;

export const city = /[a-zA-Z\u00C0-\u00FF ]{3,}$/i;

export const complement = /^[a-zA-Z0-9\s\-.ºª]{3,}$/i;

export const numberCreditCard = /^[0-9]{14}__|[0-9]{15}_|[0-9]{16}$/i;

export const numberCreditCardMaster = /^5[1-5][0-9]{14}$/i;

export const numberCreditCardVisa = /^4[0-9]{12}(?:[0-9]{3})$/i;

export const numberCreditCardAmex = /^3[47][0-9]{13}$/i;

export const numberCreditCardDiners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/i;

export const numberCreditCardElo = /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/i;

export const validationCardCredit = /^[0-1]{1}[0-9]{1}[/]([2-9][3-9])|([3-9][0-9])$/i;

// eslint-disable-next-line no-useless-escape
export const identity = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}|[0-9A-Z]{2}\.?[0-9A-Z]{3}\.?[0-9A-Z]{3}\/?[0-9A-Z]{4}\-?[0-9]{2})$/;

export const normalizeIdentityForValidation = (value?: string) =>
    (value ?? '').toUpperCase().replace(/[^0-9A-Z.\/\-]/g, '');

export const isCnpjIdentity = (value?: string): boolean => {
    const raw = (value ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    if (/[A-Z]/.test(raw)) return true;
    if (raw.length > 11) return true;
    return false;
};

export const matchesIdentity = (value?: string) =>
    identity.test(normalizeIdentityForValidation(value));

export const cep = /^[0-9]{5}-*[0-9]{3}$/i;

export const chassisOrBoard = /^[A-Z][0-9]{7}|[a-zA-Z]{3}[0-9][0-9A-Z][0-9]{2}|[0-9A-Z]{1}[a-z0-9]{12}([0-9]{4}|[0-9]{3}_)$/i;

export const boardNoMercosul = /^[a-zA-Z]{3}[0-9]{4}$/;

export const emoji = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
